import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useField } from 'react-final-form';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import { getPaySystemName } from '../../../../../../utils/cashier';
import Prompt from '../../../../../Prompt/Prompt';

import {
  TXTWCL_Before_you_continueXX,
  TXTWCL_Continue_without_bonus,
  TXTWCL_Deposit_another_way,
  TXTWCL_WeXve_found_that_N0_isnXt_elig_ELL
} from './BonusIneligiblePrompt.messages.json';

interface Props {
  onClose: () => void;
  bonusIneligibleCallback?: () => void;
}

const BonusIneligiblePrompt: React.FC<Props> = ({ onClose, bonusIneligibleCallback }) => {
  const {
    input: { value: type }
  } = useField('deposit.type', { subscription: { value: true } });

  const {
    input: { onChange }
  } = useField('deposit.bonusCode', { subscription: { value: true } });

  const { data: contextData, values } = useWizardContext();

  const systemName = getPaySystemName(contextData.paySystems, type);

  return (
    <Prompt
      variant="info"
      title={{
        translation: TXTWCL_Before_you_continueXX
      }}
      primaryButton={{ translation: TXTWCL_Deposit_another_way }}
      secondaryButton={{ translation: TXTWCL_Continue_without_bonus }}
      alert={
        <Translation {...TXTWCL_WeXve_found_that_N0_isnXt_elig_ELL} values={{ 0: systemName }} />
      }
      onSecondaryButtonClick={() => {
        onChange('');
        delete values.deposit.bonusCode;
        contextData.bonusReadySystems = [];
        bonusIneligibleCallback?.();
      }}
      onPrimaryButtonClick={onClose}
      onClose={onClose}
    />
  );
};

export default BonusIneligiblePrompt;
